import { ITextFields } from "./components/Tables";

export const ListaEvidencijaResourcesDE: ListaEvidencijaResourcesBSInterface = {
  title: "Evidenz",
  listaTacakaEvidencije: "Evidenz nach Punkten anzeigen",
  listaEvidencija: "Evidenz anzeigen",
  branchButton: "Filiale auswählen",
  errorLoading: "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
  next: "Weiter",
  back: "Zurück",
  from: "Von Datum: ",
  to: "Bis Datum: ",
  description:
    "Wählen Sie eine Filiale und einen Datumsbereich aus, um Evidenzdatensätze anzuzeigen",
  selectDateRange: "Datumsbereich auswählen",
  loadingBranches: "Filialen werden geladen...",
  loadingEvidenceRecords: "Evidenzdatensätze werden geladen...",
  loadingEvidenceList: "Evidenzliste wird geladen...",
  clickToViewDetails: "Klicken Sie, um Details anzuzeigen",
  sanEvdsList: {
    found: "Evidenz gefunden",
    notFound: "Evidenz nicht gefunden",
    download: "PDF herunterladen",
    button: "Sanitäre Evidenz anzeigen",
  },
  branch: {
    label: "Filiale",
    placeholder: "Filiale auswählen",
    notFound: "Keine Filiale gefunden",
  },
  evidencije: {
    title: "Abgeschlossene Evidenz für ausgewählten Zeitraum:",
    pojedinacneDownload: "Einzelne Evidenz PDF",
    zbirniDownload: "Sammel-Evidenz PDF",
    edit: "Bearbeiten",
  },
  pdf: {
    right: {
      title: "Ausgewählter Zeitraum: ",
      from: "Von: ",
      to: "Bis: ",
    },
    center: {
      title: "Evidenz:",
    },
  },
  poljaEvidencije: {
    CIPP_V1: "Reinigung und Waschen von Räumen",
    CIPO_V1: "Reinigung und Waschen von Geräten",
    Dezinfekcija_V1: "Desinfektion",
    Dezinsekcija_V1: "Schädlingsbekämpfung",
    Deratizacija_V1: "Nagetierkontrolle",
    Dezinsekcija_Kontrola_V1: "Schädlingsbekämpfung Kontrolle",
    Dezinskecija_Korekcija_V1: "Schädlingsbekämpfung Korrektur",
    Deratizacija_Kontrole_V1: "Nagetierkontrolle Kontrolle",
    Deratizacija_Korekcije_V1: "Nagetierkontrolle Korrektur",
    DezSr_V1: "Desinfektionsprodukte",
    Dobavljac_V1: "Lieferanten",
    Dostava_V1: "Lieferung",
    EduZap_V1: "Mitarbeiterausbildung",
    Mol_V1: "Malerarbeiten",
    Oprema_V1: "Ausrüstung",
    Otpad_V1: "Abfall",
    PrijemRobe_V1: "Wareneingang",
    San_V1: "Sanitäre Inspektion",
    Temperatura_V1: "Temperaturlisten",
    TemperaturaOgranicena_V1: "Temperaturlisten - begrenzt",
    TemperaturaOgranicenaKKT_V1: "Temperaturlisten - begrenzt - KKT",
    TemperaturaKKTProizvodiEvd_V1: "Temperaturlisten - Produkte - KKT",
  },
  pdfListaEvidencija: {
    ispunjeno: "Ausgefüllt",
    ispravnaPosiljka: "Korrekte Sendung",
    da: "Ja",
    ne: "Nein",
    proizvod: "Produkt",
    brojRacuna: "Rechnung/Lieferschein-Nummer",
    otpadKorektivnaMjera: "Angemessen gesammelter Abfall",
    tackaPrimjene: "Evidenzpunkt",
    donjaGranicaHeader: "Untergrenze",
    gornjaGranicaHeader: "Obergrenze",
    rasponHeader: "Bereich",
    odabraniPeriod: "Ausgewählter Zeitraum",
    evidencija: "Evidenz",
    period: "Ausgewählter Zeitraum: ",
    datum: "Datum und Uhrzeit",
    imeIPrezime: "Vor- und Nachname",
    imePrezime: "Vor- und Nachname",
    potpis: "Unterschrift",
    naziv: "Name",
    tipEvidencije: "Evidenztyp",
    slikaDeklaracije: "Deklarationsbild",
    opisKontrole: "Kontrollbeschreibung",
    stanjeKontrole: "Nagetierbefall",
    opisKorekcije: "Korrekturbeschreibung",
    stanjeKorekcije: "Korrekturstatus",
    primjena: "Anwendung",
    upustvoZaUpotrebu: "Gebrauchsanweisung",
    opis: "Beschreibung",
    vrsta: "Typ",
    slika: "Bild",
    address: "Adresse",
    phoneNumber: "Telefon",
    idTax: "ID-Nummer",
    pdvTax: "USt-Nummer",
    productType: "Produkttyp",
    posiljalac: "Absender",
    potpisPosiljalac: "Absender-Unterschrift",
    primalac: "Empfänger",
    potpisPrimalac: "Empfänger-Unterschrift",
    dokument: "Dokument",
    primjedba: "Kommentar/Notiz",
    korektivnaMjera: "Korrekturmaßnahme",
    temperatura: "Temperatur",
    datumObuke: "Schulungsdatum",
    mjestoObuke: "Schulungsort",
    tipObuke: "Schulungstyp",
    izvrsilacObuke: "Schulungsleiter",
    tema: "Thema",
    cilj: "Ziel",
    verifikacijaEfikasnosti: "Effizienzverifizierung",
    radnoMjesto: "Arbeitsplatz",
    verifikacijaPrisustvaPotpis: "Anwesenheitsverifizierung - Unterschrift",
    verifikacijaEdukatoraPotpis: "Ausbilder-Verifizierung - Unterschrift",
    izvrsioc: "Durchgeführt von",
    potpisIzvrsioca: "Ausführer-Unterschrift",
    uposlenik: "Mitarbeiter",
    vaziOd: "Gültig von",
    vaziDo: "Gültig bis",
    tip: "Typ",
    vrstaOtpada: "Abfalltyp",
    otpadPredao: "Abfall übergeben von",
    otpadPrimio: "Abfall erhalten von",
    kolicina: "Menge / Maßeinheit",
    primaoc: "Empfänger",
    ocitanaTemperatura: "Abgelesene Temperatur",
    dozvoljenaTempMin: "Erlaubte Mindesttemperatur",
    dozvoljenaTempMax: "Erlaubte Höchsttemperatur",
    dozvoljenoOdstupanje: "Erlaubte Abweichung",
    stanje: "Insektenbefall",
    opisMjeereKorekcije: "Korrekturmaßnahmen-Beschreibung",
    ocitanaTemperaturaKorekcije: "Abgelesene Korrekturtemperatur",
    dozvoljenaTempMinKorekcije: "Erlaubte Min.-Korrekturtemperatur",
    dozvoljenaTempMaxKorekcije: "Erlaubte Max.-Korrekturtemperatur",
    imePrezimeKorekcije: "Vor- und Nachname des Korrektur-Ausführers",
    potpisIzvrsiocaKorekcije: "Korrektur-Ausführer-Unterschrift",
    datumKorekcije: "Korrekturdatum",
    vrijemeKorekcije: "Korrekturzeit",
    zadovoljenaKontrola: "Erlaubte Temperatur",
    napomena: "Notiz",
    upisaoFooter: "Kontrolliert/Genehmigt von",
    potpisFooter: "Unterschrift",
    kontrolisaoPrimioRadove: "Kontrolliert/Arbeit erhalten",
  },
};

export interface ListaEvidencijaResourcesBSInterface {
  title: string;
  listaTacakaEvidencije: string;
  listaEvidencija: string;
  errorLoading: string;
  branchButton: string;
  next: string;
  back: string;
  from: string;
  to: string;
  description: string;
  selectDateRange: string;
  loadingBranches: string;
  loadingEvidenceRecords: string;
  loadingEvidenceList: string;
  clickToViewDetails: string;
  branch: {
    label: string;
    placeholder: string;
    notFound: string;
  };
  evidencije: {
    title: string;
    pojedinacneDownload: string;
    zbirniDownload: string;
    edit: string;
  };
  pdf: {
    right: {
      title: string;
      from: string;
      to: string;
    };
    center: {
      title: string;
    };
  };
  poljaEvidencije: {
    CIPP_V1: string;
    CIPO_V1: string;
    Dezinfekcija_V1: string;
    Dezinsekcija_V1: string;
    Deratizacija_V1: string;
    Dezinsekcija_Kontrola_V1: string;
    Dezinskecija_Korekcija_V1: string;
    Deratizacija_Kontrole_V1: string;
    Deratizacija_Korekcije_V1: string;
    DezSr_V1: string;
    Dobavljac_V1: string;
    Dostava_V1: string;
    EduZap_V1: string;
    Mol_V1: string;
    Oprema_V1: string;
    Otpad_V1: string;
    PrijemRobe_V1: string;
    San_V1: string;
    Temperatura_V1: string;
    TemperaturaOgranicena_V1: string;
    TemperaturaOgranicenaKKT_V1: string;
    TemperaturaKKTProizvodiEvd_V1: string;
  };
  pdfListaEvidencija: ITextFields;
  sanEvdsList: {
    found: string;
    notFound: string;
    download: string;
    button: string;
  };
}
